import { render, staticRenderFns } from "./PerfilPaciente.vue?vue&type=template&id=13022007&scoped=true&lang=pug"
import script from "./PerfilPaciente.vue?vue&type=script&lang=js"
export * from "./PerfilPaciente.vue?vue&type=script&lang=js"
import style0 from "./PerfilPaciente.vue?vue&type=style&index=0&id=13022007&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13022007",
  null
  
)

export default component.exports